import React from 'react'
import './Button.css'

function Button({ text }) {
    return (
        <div className="button">
            <p>{text}</p>
        </div>
    )
}

export default Button
